import { render, staticRenderFns } from "./LikeComponent.vue?vue&type=template&id=61247f9a&scoped=true&"
import script from "./LikeComponent.vue?vue&type=script&lang=js&"
export * from "./LikeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61247f9a",
  null
  
)

export default component.exports